import _get from 'lodash/get';
import { isUserAuthenticatedAsync } from 'helper/auth-helper';
import { logout } from 'grab-login/lib/helper';
import fetchUtil from 'common/utils/fetch';
import loginEndpoints from 'actions/login-endpoints';
import {
  getCompanyID,
  tempSaveUserProfile,
  getUserCountryCode,
} from 'helper/user';
import { buildHeaders } from 'actions/fetch-helper';
import {
  fetchPaxUserInfo,
  getPaxAccessToken,
  isPaxUser,
  isGrabIDAuthenticated,
  savePaxUserInfo,
  grabIDLogout,
} from 'helper/grab-id-auth-helper';
import Storage from 'grab-storage';
import { STORAGE_PAX_NOT_WHITElISTED } from 'constants/app-constants';
import { buildCredentials } from './session-helper';
import { enableEnterpriseApiDeprecation } from '../actions/feature-flag-helper';

const setDefaultFeatureFlags = () => {
  window.Grab.config.features = {
    enableUIV2: true,
  };
};

const saveConfigToWindow = rawConfiguration => {
  window.Grab.config.features = _get(rawConfiguration, 'configuration', {
    enableUIV2: true,
    enableShopifyOrders: false,
  });
};

const setPaxNotWhitelisted = () => {
  if (isPaxUser()) {
    Storage.setItem(STORAGE_PAX_NOT_WHITElISTED, true);
  }
};

export const isPaxNotWhitelisted = () => {
  const storedValue = Storage.getItem(STORAGE_PAX_NOT_WHITElISTED);
  Storage.removeItem(STORAGE_PAX_NOT_WHITElISTED);
  return storedValue === 'true';
};

const fetchCompanyUserProfilesAsync = async () => {
  const useGrabExpressCompanyUserProfiles = enableEnterpriseApiDeprecation();

  if (useGrabExpressCompanyUserProfiles) {
    const response = await fetchUtil(
      loginEndpoints.getCompanyUserProfilesEpt(),
      {
        headers: buildHeaders(null, null, null, true),
        credentials: buildCredentials(),
      },
    );
    return _get(response, 'response', {});
  }

  // TODO: deprecate after flag rollout
  return await fetchUtil(loginEndpoints.fetchUserInfoEpt(), {
    headers: buildHeaders(),
    credentials: buildCredentials(),
  });
};

export const getUserFeatureFlagsAsync = async () =>
  await isUserAuthenticatedAsync()
    .then(async isUserAuthenticated => {
      if (!isUserAuthenticated) {
        setDefaultFeatureFlags();
        return;
      }
      // this checks if user is a Authenticated PAX
      if (isGrabIDAuthenticated()) {
        const [paxUserData, paxConfiguration] = await Promise.all([
          fetchPaxUserInfo(getPaxAccessToken()),
          fetchUtil(
            loginEndpoints.paxGetUserConfiguration(getUserCountryCode()),
            {
              headers: buildHeaders(),
            },
          ),
        ]);
        savePaxUserInfo(paxUserData);
        saveConfigToWindow(paxConfiguration);
      } else {
        const corpUserProfile = await fetchCompanyUserProfilesAsync();

        const companyID = getCompanyID(corpUserProfile);
        const corpConfigResponse = await fetchUtil(
          loginEndpoints.getUserConfiguration(companyID),
          {
            headers: buildHeaders(null, null, companyID, true),
            credentials: buildCredentials(),
          },
        );
        // temporary use in global-init-client epic, delete after the use
        tempSaveUserProfile(corpUserProfile);
        saveConfigToWindow(corpConfigResponse);
      }
    })
    .catch(err => {
      setDefaultFeatureFlags();
      if (err.status === 401) {
        logout();
      }
      if (err.status === 403) {
        // Block VN users from sign in.
        grabIDLogout();
        setPaxNotWhitelisted();
      }
    });

export default {};
